import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as MenuCloseSvg } from 'assets/menuClose.svg';

const MenuCloseIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props} component={MenuCloseSvg} />;
};

export default MenuCloseIcon;
